import { useGeneralSettings } from '../../hooks/useGeneralSettings'

const FALLBACK_PHONE = '+91 98765 43210'

const val = (v) => (typeof v === 'string' && v.trim() ? v.trim() : '')

/** tel: wants digits; bare 10-digit Indian numbers get the 91 prefix. */
const telDigits = (raw) => {
  const digits = raw.replace(/\D/g, '')
  return digits.length === 10 ? `91${digits}` : digits
}

/** Pretty-print Indian numbers as +91 XXXXX XXXXX; anything else shows as sent. */
const displayPhone = (raw) => {
  const digits = raw.replace(/\D/g, '')
  if (digits.length === 10) return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`
  if (digits.length === 12 && digits.startsWith('91')) return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`
  return raw
}

export default function CallDropdown({ open }) {
  const { settings } = useGeneralSettings()
  const phone = val(settings.support_phone) || val(settings.phone) || FALLBACK_PHONE

  return (
    <div
      className={`${open ? '' : 'hidden'} header-dropdown absolute right-0 mt-3 w-64 bg-astroDeep/95 backdrop-blur-2xl border border-white/10 rounded-2xl p-4 shadow-2xl text-center space-y-3 z-50`}
      onClick={(e) => e.stopPropagation()}
    >
      <p className="text-[10px] uppercase tracking-widest text-white/50 font-bold">Divine Support Desk</p>
      <p className="text-sm font-semibold text-goldPrimary">{displayPhone(phone)}</p>
      <p className="text-[10px] text-white/40">Available daily: 09:00 AM - 09:00 PM IST</p>
      <a
        href={`tel:+${telDigits(phone)}`}
        className="block w-full bg-goldPrimary hover:bg-goldAccent text-astroDark font-bold py-2 rounded-xl text-xs transition-colors"
      >
        Call Now
      </a>
    </div>
  )
}
